import {
  Button,
  FormControl,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
  Grid
} from '@material-ui/core';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles
} from '@material-ui/core/styles';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import 'date-fns';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { getEmployeeMasterList } from '../apicalls/employeeMaster';
import '../App.css';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import { DatePickerInput } from '../components/atoms';
import FooterComponent from '../components/FooterComponent';
import LoadingComponent from '../components/LoadingComponent';
import PaginationComponent from '../components/PaginationComponent';
import {
  btnColor,
  estimatesData,
  isLoggedIn,
  mainBlueColor,
  userMenuId,
  userRole
} from '../GlobalState';
import './List.css';
import { searchDocumentSendHistories } from '../apicalls/documentTransmissionPage';
import { TDocumentSendHistorie } from '../types/DocumentTransmissionPage';
import { formatDatetime } from '../utils/common';
import { BasicSelect } from '../components/parts/input/BasicSelect';
import { useTheme } from '@material-ui/core/styles';
import { EMPLOYEE_TYPE } from '../const/Const';
import { getUserSelectOptions } from '../utils/processAndTaskFormUtils';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
      '&:hover': {
        backgroundColor: '#CFCFCF'
      }
    }
  }
}))(TableRow);

export const DocumentTransmissionPage: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);
  const matches = useMediaQuery('(min-width:600px)');

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      formControl: {
        minWidth: 120,
        backgroundColor: '#FFFFFF'
      },
      formControl1: {
        minWidth: 120,
        height: 30,
        borderRadius: 5,
        borderWidth: 1,
        paddingLeft: 5
      },
      container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 15
      },
      main: {
        minWidth: 700
      },
      table: {
        padding: 8,
        backgroundColor: `${mainColor} !important`,
        color: '#FFFFFF',
        fontWeight: 'bold',
        fontSize: 16
      },
      input: {
        borderColor: '#CCCCCC',
        padding: 5,
        margin: 10
      },
      table1: {
        // padding: 8,
      },
      topBoxText: {
        fontSize: 14,
        color: '#FFFFFF'
      },
      topContainer: {
        display: 'flex',
        paddingBottom: 15,
        justifyContent: 'space-between'
      },
      btnContainer: {
        display: 'flex',
        flexDirection: matches ? 'row' : 'column',
        alignItems: 'center'
      },
      inputBottom: {
        height: 30,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      tooltip: {
        maxWidth: 250,
        fontSize: 14
      },
      searchField: {
        overflow: 'hidden',
        width: window.innerWidth,
        display: 'flex',
        flexWrap: 'wrap'
      },
      copyStateMessage: {
        // リンクURLコピーの成否メッセージ
        position: 'fixed',
        left: 60,
        bottom: 60,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: 300,
        padding: '12px 24px',
        borderRadius: 8,
        color: 'white',
        backgroundColor: 'black',
        fontSize: 14,
        opacity: 0.8
      }
    })
  );

  const classes = useStyles();

  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );
  const [open, setOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [documentSendHistories, setDocumentSendHistories] = useState<
    TDocumentSendHistorie[]
  >([]);
  const [selectedFromDate, setSelectedFromDate] = useState<Date | null>(null);
  const [selectedEndDate, setSelectedEndDate] = useState<Date | null>(null);
  const [status, setStatus] = useState<number>(0);
  const [salesUserId, setSalesUserId] = useState<number>(0);
  const [submissionFromDate, setSubmissionFromDate] = useState('');
  const [submissionEndDate, setSubmissionEndDate] = useState('');
  const [billingCustomerName, setBillingCustomerName] = useState('');
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [estimatesApiData, setEstimatesApiData] = useRecoilState(estimatesData);
  const [loading, setLoading] = useState(
    estimatesApiData !== null ? false : true
  );
  const [userData, setUserData] = useState<any>([]);
  const [userMenu] = useRecoilState<any>(userMenuId);

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleFromDateChange = (date: Date | null) => {
    setSelectedFromDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }

    if (finaldate) {
      setSubmissionFromDate(`${finaldate} 00:00:00`);
    } else {
      setSubmissionFromDate('');
    }
  };

  const handleEndDateChange = (date: Date | null) => {
    setSelectedEndDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }

    if (finaldate) {
      setSubmissionEndDate(`${finaldate} 23:59:59`);
    } else {
      setSubmissionEndDate('');
    }
  };

  useEffect(() => {
    getListOfUsers();
    getDocumentSendHistories();
  }, [currentPage]);

  const getDocumentSendHistories = () => {
    const param = `?start_datetime=${submissionFromDate}&end_datetime=${submissionEndDate}&sender_user_id=${salesUserId}&status=${status}&keyword=${billingCustomerName}&page=${currentPage}`;
    searchDocumentSendHistories(param) // 共有先を認証し、アクセストークンをセット
      .then(data => {
        if (data.data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data.data === 'string') {
            setErrorMessage(data.data);
            setOpen(true);
          } else {
            setLoading(false);
            setDocumentSendHistories(data.data);
            setPageCount(data.page_count);
          }
        }
      });
  };

  const getListOfUsers = () => {
    getEmployeeMasterList('', 1, 0, EMPLOYEE_TYPE['INSIDE_EMPLOYEE']).then(
      data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setUserData(data.data);
            }
          }
        }
      }
    );
  };

  // サイズ調整
  const theme = useTheme();
  const isSmDownScreen = useMediaQuery(theme.breakpoints.up('sm'));

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  if (userMenu == 'Storage') {
    return (
      <Redirect
        to={{
          pathname: '/constructions'
        }}
      />
    );
  }

  return (
    <div style={{ backgroundColor: '#F5F5F5' }}>
      <AppBarComponent patternName='mailsendlog' />
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent />
        </>
      ) : (
        <div
          style={{
            overflow: 'hidden',
            backgroundColor: '#F5F5F5',
            padding: 15,
            minHeight: window.innerHeight - 150
          }}
        >
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>

          <div
            style={{ padding: 15, backgroundColor: '#FFFFFF', borderRadius: 5 }}
          >
            <div style={{ backgroundColor: '#FFFFFF' }}>
              <div
                style={{
                  fontWeight: 'bold',
                  padding: 15,
                  fontSize: 24
                }}
              >
                メール送信履歴
              </div>
            </div>
            <Grid container>
              <Grid item xs={12} className={classes.searchField}>
                <div
                  style={{
                    marginBottom: 10,
                    marginRight: 20,
                    backgroundColor: '#FFFFFF',
                    height: 35,
                    paddingBottom: 5,
                    paddingLeft: 5
                  }}
                  className={'select-div'}
                >
                  <DatePickerInput
                    id='date-picker-inline'
                    date={selectedFromDate}
                    emptyLabel='期間'
                    onChange={handleFromDateChange}
                    maxDate={selectedEndDate ? selectedEndDate : undefined}
                  />
                </div>
                <span style={{ marginRight: '20px', fontSize: '20px' }}>~</span>
                <div
                  style={{
                    marginBottom: 10,
                    marginRight: 20,
                    backgroundColor: '#FFFFFF',
                    height: 35,
                    paddingBottom: 5,
                    paddingLeft: 5
                  }}
                  className={'select-div'}
                >
                  <DatePickerInput
                    id='date-picker-inline'
                    date={selectedEndDate}
                    emptyLabel='期間'
                    onChange={handleEndDateChange}
                    minDate={selectedFromDate ? selectedFromDate : undefined}
                  />
                </div>
                <div
                  style={{ marginRight: 20, marginBottom: 10 }}
                  className='select-div'
                >
                  <div style={{ paddingLeft: 5 }}>
                    <FormControl className={classes.formControl}>
                      <BasicSelect
                        value={salesUserId}
                        onChange={e => {
                          setSalesUserId(parseInt(e.target.value));
                        }}
                        inputProps={{ 'aria-label': 'age' }}
                        disableUnderline
                      >
                        <option value={0}>送信者</option>
                        {getUserSelectOptions(userData)}
                      </BasicSelect>
                    </FormControl>
                  </div>
                </div>
                <div
                  style={{ marginRight: 20, marginBottom: 10 }}
                  className='select-div'
                >
                  <div style={{ paddingLeft: 5 }}>
                    <FormControl className={classes.formControl}>
                      <BasicSelect
                        value={status}
                        onChange={e => {
                          setStatus(parseInt(e.target.value));
                        }}
                        inputProps={{ 'aria-label': 'age' }}
                        disableUnderline
                      >
                        <option value={0}>ステータス</option>
                        <option value={1}>未開封</option>
                        <option value={2}>開封済</option>
                        <option value={3}>ダウンロード済</option>
                      </BasicSelect>
                    </FormControl>
                  </div>
                </div>
                <div>
                  <input
                    value={billingCustomerName}
                    maxLength={80}
                    onChange={e => {
                      setBillingCustomerName(e.target.value);
                    }}
                    style={{
                      width: isSmDownScreen ? 'none' : '100%',
                      marginBottom: 10,
                      marginRight: 20,
                      height: 35,
                      backgroundColor: '#FFFFFF'
                    }}
                    className={classes.formControl1}
                    placeholder='キーワード'
                  />
                </div>
                <div>
                  <Button
                    style={{
                      marginBottom: 10,
                      marginRight: 20,
                      marginLeft: 10,
                      backgroundColor: buttonColor
                    }}
                    variant='contained'
                    color='primary'
                    onClick={() => getDocumentSendHistories()}
                  >
                    検索
                  </Button>
                </div>
              </Grid>
            </Grid>

            <TableContainer component={Paper}>
              <Table className={classes.main} aria-label='customized table'>
                <TableHead>
                  <TableRow>
                    <StyledTableCell
                      style={{ minWidth: 80 }}
                      className={classes.table}
                      align='center'
                    >
                      送信日時
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ minWidth: 80 }}
                      className={classes.table}
                      align='center'
                    >
                      送信先
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ minWidth: 250 }}
                      className={classes.table}
                      align='center'
                    >
                      書類名
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ minWidth: 120 }}
                      className={classes.table}
                      align='center'
                    >
                      送信者
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ minWidth: 80 }}
                      className={classes.table}
                      align='center'
                    >
                      ステータス
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {documentSendHistories &&
                    documentSendHistories.length > 0 &&
                    documentSendHistories.map(
                      (
                        documentSendHistorie: TDocumentSendHistorie,
                        index: number
                      ) => (
                        <StyledTableRow className='click_table_row'>
                          <StyledTableCell
                            className={classes.table1}
                            align='center'
                          >
                            {documentSendHistorie.sent_datetime}
                          </StyledTableCell>
                          <StyledTableCell
                            className={classes.table1}
                            align='center'
                          >
                            {`${documentSendHistorie.to_company_name}　${documentSendHistorie.to_name}`}
                          </StyledTableCell>
                          <StyledTableCell
                            className={classes.table1}
                            align='center'
                          >
                            {documentSendHistorie.document_name}
                          </StyledTableCell>
                          <StyledTableCell
                            className={classes.table1}
                            align='center'
                          >
                            {documentSendHistorie.sender_user}
                          </StyledTableCell>
                          <StyledTableCell
                            className={classes.table1}
                            align='center'
                          >
                            {documentSendHistorie.status}
                          </StyledTableCell>
                        </StyledTableRow>
                      )
                    )}
                </TableBody>
              </Table>
              {!loading &&
                documentSendHistories &&
                documentSendHistories.length === 0 && (
                  <div className={classes.container}>データがありません</div>
                )}
            </TableContainer>
            <PaginationComponent
              page={currentPage}
              pageCount={pageCount}
              setCurrentPage={setCurrentPage}
            />
          </div>
        </div>
      )}
      <FooterComponent />
    </div>
  );
};
